import CryptoJS from 'crypto-js'


const CONFIG = {
    // 密钥：支持 16字节(128位) / 24字节(192位) / 32字节(256位)
    key: 'KalistaSamira666',   // 16位，建议改成你自己的
    iv: 'd82be6bbc1da11eb',      // 16位偏移量（CBC模式需要）
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
};

export function samira(cipherText) {
    // 空值直接返回
    if (cipherText === null || cipherText === undefined || cipherText === '') {
        return cipherText;
    }

    // 如果不是字符串，转成字符串
    const text = String(cipherText);

    const key = CryptoJS.enc.Utf8.parse(CONFIG.key);
    const iv = CryptoJS.enc.Utf8.parse(CONFIG.iv);

    const decrypted = CryptoJS.AES.decrypt(text, key, {
        iv: iv,
        mode: CONFIG.mode,
        padding: CONFIG.padding
    });

    const result = decrypted.toString(CryptoJS.enc.Utf8);

    return result;
}
